import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { OAuthService, OAuthErrorEvent } from 'angular-oauth2-oidc';

import { AuthHelperService } from '@iws-ux/auth';

import { MonitoringService } from '../../services/Monitoring/Monitoring.service';

@Component({
    selector: 'imago-direct',
    templateUrl: './app.component.html'
})

export class AppComponent {
    /**
     * .
     *
     * @type {boolean}
     * @public
     */
    public userHasAccessToConfiguration: boolean = false;

    public thisRoute: string = "undefined";
    public isNavigating: boolean = false;

    angularClientSideData = 'Angular';

    private static readonly DarkModeKey = 'iws-dark-mode';
    public isDarkMode: boolean = false;

    toggleDarkMode(): void {
        this.isDarkMode = !this.isDarkMode;
        localStorage.setItem(AppComponent.DarkModeKey, this.isDarkMode ? '1' : '0');
        document.body.classList.toggle('iws-dark-mode', this.isDarkMode);
    }

    // ----------------------------------------------------------------------------
    public constructor(
        private titleService: Title,
        private monitoringService: MonitoringService,
        private oauthService: OAuthService,
        private authHelperService: AuthHelperService,
        private router: Router,
        ar: ActivatedRoute) {
        this.monitoringService.logTrace("Automation SPA client starting...");

        this.isDarkMode = localStorage.getItem(AppComponent.DarkModeKey) === '1';
        document.body.classList.toggle('iws-dark-mode', this.isDarkMode);

        this.userHasAccessToConfiguration = this.authHelperService.userHasPermission(['automation.administrator']);

        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.isNavigating = true;
                document.body.classList.add('is-navigating');
            }

            if (event instanceof NavigationEnd) {
                this.isNavigating = false;
                document.body.classList.remove('is-navigating');
                monitoringService.logPageView("IWS Automation SPA", event.url);
                this.thisRoute = event.url;
            }

            if (event instanceof NavigationCancel || event instanceof NavigationError) {
                this.isNavigating = false;
                document.body.classList.remove('is-navigating');
            }
        });

        this.oauthService.events.subscribe(event => {
            this.monitoringService.logEvent("OAuthEvent", event);

            if (event instanceof OAuthErrorEvent) {
                // Code cribbed from: https://stackoverflow.com/a/51767065/962543

                // Subset of situations from https://openid.net/specs/openid-connect-core-1_0.html#AuthError
                // Only the ones where it's reasonably sure that sending the user to the IdServer will help.
                const errorResponsesRequiringUserInteraction = [
                    'interaction_required',
                    'login_required',
                    'account_selection_required',
                    'consent_required'
                ];

                if (event.type == "silent_refresh_error") {
                    if (event.reason && errorResponsesRequiringUserInteraction.indexOf(event.reason["error"]) >= 0) {
                        this.monitoringService.logEvent("silent_refresh_error reason", event.reason);
                        this.monitoringService.logEvent("silent_refresh_error params", event.params);

                        // At this point we know for sure that we have to ask the user to
                        // log in, so we redirect them to the IdServer to enter credentials:

                        this.oauthService.initImplicitFlow();
                    }
                } else if (event.type == "token_error") {
                    if (event.params && errorResponsesRequiringUserInteraction.indexOf(event.params["error"]) >= 0) {
                        this.monitoringService.logEvent("token_error reason", event.reason);
                        this.monitoringService.logEvent("token_error params", event.params);

                        this.oauthService.initImplicitFlow();
                    }
                }
            }
        });
    }

    // ----------------------------------------------------------------------------
    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    // ----------------------------------------------------------------------------
    public showProfilePage() {
        this.router.navigate(['/profile']);
    }

    get showDeveloperOptions(): boolean {
        return this.authHelperService.userHasPermission(['automation.feature.debugMode']);
    }
}